import { render } from "./ItemUniqueComponent.vue?vue&type=template&id=2beefef0"
import script from "./ItemUniqueComponent.vue?vue&type=script&lang=js"
export * from "./ItemUniqueComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__